import httpRequest from "services/httpRequest";

const prefix = "/api/daily-message";

export const onGetDailyMessage = async body => {
  return await httpRequest({
    url: `${prefix}`,
    method: "GET",
    data: body,
  });
};

export const onCreateDailyMessage = async body => {
  return await httpRequest({
    url: `${prefix}`,
    method: "POST",
    data: body,
    successMessage: "toast.create_success",
  });
};

export const onUpdateDailyMessage = async params => {
  return await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "PUT",
    data: params,
    successMessage: "toast.update_success",
  });
};

export const onDeleteDailyMessage = async params => {
  return await httpRequest({
    url: `${prefix}/${params.id}`,
    method: "DELETE",
    successMessage: "toast.delete_success",
  });
};
